import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const iconContainerBaseStyles = ({ theme }) => css`
  display: block;
  position: relative;
  cursor: pointer;
  width: 25px;
  height: 25px;
  border: none;
  background: none;

  &:before,
  &:after {
    position: absolute;
    top: 0;
    left: 12px;
    content: ' ';
    height: 25px;
    width: 2px;
    background-color: ${theme.colors.white};
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

const IconContainer = styled('button')`
  ${iconContainerBaseStyles};
`;

const Close = (props) => <IconContainer {...props} />;

export default Close;
